module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v(" handful of people have been especially helpful to me in the creation of this book. Rod McDaniel contributed several important terms, such as “home frequency,” that dramatically and immediately aligned and opened me to new insights and information. I’m also grateful for his clarifying feedback on the manuscript and some of his beautiful, original translations of Rainer Maria Rilke’s work. Others patiently read the first draft and gave me great insights as well. Much appreciation goes to Darryl Lundahl, Cameron Hogan, Pam Kramer, Henry Smiley, Anne Lewis, Barbara Haury, Anthony Wright, Jim White, and Joan Charles. I am also deeply thankful to my mother, Skip Eby, and my sister, Paula Peirce, for their interest, reality checks, and loyal support, even if they’re not always sure what I’m talking about. Thanks, too, to Chris Lenz and Karen Malik from The Monroe Institute for their precise input.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Working with Cynthia Black and the team at Beyond Words Publishing has been a sweet experience. They took a chance on me long ago, publishing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Intuitive Way")]), _vm._v(", and I am happy to be back with them. They are sophisticated and warm, and Cindy has been a real support as I have moved into this new territory. Marie Hix has been upbeat and unfailingly helpful, weaving the threads of the project together. I couldn’t have asked for a more talented, knowledgeable, and considerate editor than Julie Steigerwaldt. Thanks, too, to Lindsay Brown, Sara Blum, Devon Smith, and Bill Brunson.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finally, I am grateful to Michael Bernard Beckwith for taking the time to write such a wonderful foreword.")])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4997bbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416546375_fm01.vue
// module id = 72
// module chunks = 0